import { func, string } from "prop-types";
import { forwardRef, useCallback } from "react";

import cloneDeep from "lodash/cloneDeep";

import { formatPhoneNumber } from "Utilities/Number";
import retainInputCursorPos from "Utilities/retainInputCursorPos";

import DefaultInput from "../DefaultInput";

const PhoneInput = forwardRef(
  ({ value, onChange: onChangeArg, ...rest }, ref) => {
    const onChange = useCallback(
      (event) => {
        const clonedEvent = cloneDeep(event);
        const newValue = clonedEvent.target.value;
        let finalValue = formatPhoneNumber(newValue);

        // Schedule to resetting of the cursor in while we still know where it is
        retainInputCursorPos(clonedEvent.target, { ignoreIfAtEnd: true });

        // set the new value via the cloned event
        clonedEvent.target.value = finalValue;
        onChangeArg(clonedEvent);
      },
      [onChangeArg]
    );

    return (
      <DefaultInput
        onChange={onChange}
        value={value ? formatPhoneNumber(value) : ""}
        ref={ref}
        {...rest}
      />
    );
  }
);

PhoneInput.propTypes = {
  value: string,
  onChange: func,
};

export default PhoneInput;
